"use client";
import { FC } from "react";
import { NewGlobalSimpleFooter } from "./NewGlobalSimpleFooter";
import { getDataAutomationGroup, getDataLinkAttributes } from "@/helpers";
import cn from "classnames";
import { Theme } from "@/types";
import Link from "@/components/Link";

export type LinkProps = {
  title: string;
  href: string;
  isDoNotSellLink?: boolean;
  doNotSellAriaLabel?: string;
  dlt?: string;
  dld?: string;
};

declare global {
  interface Window {
    Optanon?: {
      ToggleInfoDisplay: () => void;
    };
  }
}

export type SWDCGlobalSimpleFooterProps = {
  theme?: Theme;
  legal_links: Array<LinkProps>;
  copyright: string;
  animatedTopLine?: boolean;
};

export const SWDCGlobalSimpleFooter: FC<SWDCGlobalSimpleFooterProps> = ({
  legal_links,
  theme,
  copyright,
  animatedTopLine = false,
}) => {
  return theme === "white" ? (
    <NewGlobalSimpleFooter
      legal_links={legal_links}
      copyright={copyright}
      animatedTopLine={animatedTopLine}
    />
  ) : (
    <footer
      data-theme={theme}
      className="bg-background mt-auto overflow-x-hidden"
    >
      <div
        className={cn(
          theme === "gray"
            ? "bg-swdc-gray-50"
            : "bg-swdc-gray-500 text-swdc-gray-50",
        )}
      >
        <ul className="swdc-container text-link-xs text-body-primary flex flex-wrap gap-x-2 gap-y-1.5 py-4">
          {legal_links.map(
            (
              { title, href, isDoNotSellLink, doNotSellAriaLabel, dlt, dld },
              index,
            ) => (
              <li
                key={`${title}-${index}`}
                className={cn(
                  "my-1.5 pr-2 leading-6",
                  index !== legal_links.length - 1 &&
                    "border-body-secondary border-r",
                )}
              >
                {isDoNotSellLink ? (
                  <button
                    type="button"
                    aria-label={doNotSellAriaLabel || title}
                    onClick={() => {
                      if (window && window.Optanon) {
                        window.Optanon.ToggleInfoDisplay();
                      }
                    }}
                    {...getDataLinkAttributes({
                      dlt: dlt || "Footer",
                      dld: dld || `${title} link`,
                    })}
                    {...getDataAutomationGroup("link")}
                    className="active:text-link-pressed hover:underline active:underline"
                  >
                    {title}
                  </button>
                ) : (
                  <Link
                    href={href}
                    {...getDataLinkAttributes({
                      dlt: dlt || "Footer",
                      dld: dld || `${title} link`,
                    })}
                    {...getDataAutomationGroup("legal-links")}
                    className="active:text-link-pressed hover:underline active:underline"
                  >
                    {title}
                  </Link>
                )}
              </li>
            ),
          )}
        </ul>
      </div>
      <div
        className={cn(
          theme === "gray"
            ? "bg-swdc-gray-500 text-swdc-gray-50"
            : "bg-swdc-gray-50 text-swdc-gray-400",
        )}
      >
        <p className="swdc-container text-link-xs py-4 leading-6 lg:py-4">
          {copyright}
        </p>
      </div>
    </footer>
  );
};

export default SWDCGlobalSimpleFooter;
